<template>
  <v-app>
    <v-app-bar color="primary" dark app fixed>
      <!-- <v-toolbar-title style="margin-right: 100px">Sistema Gerencial</v-toolbar-title> -->

      <v-toolbar-items>
        <v-menu offset-y min-width="200">
          <template v-slot:activator="{ on }">
            <v-btn class="text-capitalize" text color="white" dark v-on="on"
              >Cadastros</v-btn
            >
          </template>
          <v-list>
            <v-list-item-group color="primary">
              <v-list-item to="/cadastros/clientes">
                <v-list-item-title>Clientes</v-list-item-title>
              </v-list-item>
              <v-list-item to="/cadastros/fornecedores">
                <v-list-item-title>Fornecedores</v-list-item-title>
              </v-list-item>
              <v-list-item to="/cadastros/vendedores">
                <v-list-item-title>Vendedores</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>

        <v-menu offset-y min-width="200">
          <template v-slot:activator="{ on }">
            <v-btn class="text-capitalize" text color="white" dark v-on="on"
              >Produtos</v-btn
            >
          </template>
          <v-list>
            <v-list-item to="/catalogo/produtos">
              <v-list-item-title>Cadastro de Produtos</v-list-item-title>
            </v-list-item>
            <v-list-item to="/catalogo/movimentoestoque">
              <v-list-item-title>Movimento de Estoque</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y min-width="200">
          <template v-slot:activator="{ on }">
            <v-btn class="text-capitalize" text color="white" dark v-on="on"
              >Vendas</v-btn
            >
          </template>
          <v-list>
            <v-list-item to="/vendas/pedidos">
              <v-list-item-title>Pedidos</v-list-item-title>
            </v-list-item>
            <v-list-item to="/i/Devoluções" disabled>
              <v-list-item-title>Devoluções</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y min-width="200">
          <template v-slot:activator="{ on }">
            <v-btn class="text-capitalize" text color="white" dark v-on="on">Cheques</v-btn>
          </template>
          <v-list>
            <v-list-item to="/cheques/controle">
              <v-list-item-title>Controle de Cheques</v-list-item-title>
            </v-list-item>
            <v-list-item to="/cheques/remessa" disabled>
              <v-list-item-title>Remessa de Cheques</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y min-width="200">
          <template v-slot:activator="{ on }">
            <v-btn class="text-capitalize" text color="white" dark v-on="on">Financeiro</v-btn>
          </template>
          <v-list>
            <v-list-item to="/financeiro/extratocliente">
              <v-list-item-title>Extrato do Cliente</v-list-item-title>
            </v-list-item>
            <v-list-item to="/financeiro/caixa">
              <v-list-item-title>Caixa</v-list-item-title>
            </v-list-item>
            <v-list-item to="/financeiro/contasapagar" disabled>
              <v-list-item-title>Contas a Pagar</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn class="text-capitalize" text color="white" dark to="/relatorios"
          >Relatórios</v-btn
        >

        <v-menu offset-y min-width="200" tile>
          <template v-slot:activator="{ on }">
            <v-btn class="text-capitalize" text color="white" dark v-on="on">Usuários</v-btn>
          </template>
          <v-list>
            <v-list-item to="/sistema/usuarios">
              <v-list-item-title>Usuários</v-list-item-title>
            </v-list-item>
            <v-list-item to="/sistema/permissoes">
              <v-list-item-title>Permissões</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>

      <v-progress-circular
        v-show="loading"
        indeterminate
        :size="25"
        :width="3"
        color="white"
        class="ml-4"
      ></v-progress-circular>
      <v-spacer></v-spacer>

      <span v-if="!config.IS_PRODUCTION">[ Breakpoint: {{ $vuetify.breakpoint.name }} ]</span>
      <v-btn icon text @click="$router.push('/')" v-if="!config.IS_PRODUCTION">
        <v-icon>home</v-icon>
      </v-btn>
      <v-btn icon text @click="$router.push('/vendas/pedidos')">
        <v-icon>shopping_cart</v-icon>
      </v-btn>
      <v-menu offset-y origin="center center" :nudge-bottom="10">
        <template v-slot:activator="{ on }">
          <v-btn icon text v-on="on">
            <v-avatar size="36px">
              <!-- <img src="https://pt.gravatar.com/userimage/137219454/70437e2a847a7a971a437def22577a44.jpg" alt="Michael Wang"/> -->
              <v-icon>person</v-icon>
            </v-avatar>
          </v-btn>
        </template>

        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <!-- <img src="https://pt.gravatar.com/userimage/137219454/70437e2a847a7a971a437def22577a44.jpg" alt="John"> -->
                <v-icon>person</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{
                  $auth.getUser().name
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  $auth.getUser().perfil.descricao
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list class="pa-0">
            <v-list-item
              v-for="(item, index) in items2"
              :to="!item.href ? { name: item.name } : null"
              :href="item.href"
              @click="item.click"
              ripple="ripple"
              :disabled="item.disabled"
              :target="item.target"
              rel="noopener"
              :key="index"
            >
              <v-list-item-action v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-content>
      <v-slide-y-transition mode="out-in">
        <router-view />
      </v-slide-y-transition>
    </v-content>

    <v-snackbar
      bottom
      v-model="snackbar.exibir"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
    >
      {{ snackbar.mensagem }}
      <v-btn dark text color="primary" @click.native="snackbar.exibir = false"
        >Fechar</v-btn
      >
      <v-btn dark text color="primary" @click.native="snackbar.exibir = false"
        >Detalhes</v-btn
      >
    </v-snackbar>

    <z-notificacao ref="notificacao"></z-notificacao>
  </v-app>
</template>

<script>
import events from "@/app/mixins/events";
import config from "@/app/config";
import { mapState } from "vuex";

export default {
  name: "AppLayout2",
  mixins: [events],
  data() {
    return {
      config: config,
      right: true,
      rightDrawer: false,
      title: "Tela Inicial",
      snackbar: {
        exibir: false,
        mensagem: "",
        timeout: 3000,
        color: "",
      },
      menu_cadastros: [
        { texto: "Clientes" },
        { texto: "Fornecedores" },
        { texto: "Vendedores" },
      ],
    };
  },

  mounted() {
    this.$store.dispatch("carregarConfiguracoes");
  },

  computed: {
    ...mapState({
      tituloTela: (state) => state.titulo_tela,
      loading: (state) => state.loading,
    }),

    styleContent() {
      return {
        paddingLeft: !this.drawer ? "" : "250px !important",
      };
    },

    drawer_clientes() {
      return this.$store.state.financeiro.drawer_clientes;
    },
  },
};
</script>
